import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconDroplet = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--droplet")} iconColor={color} size={size} width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

      <defs>
          <path d="M7.056875,9.05733849 C5.05393767,11.0589634 4.45420631,14.0701481 5.53740439,16.6864321 C6.62060247,19.3027162 9.17334674,21.0087079 12.005,21.0087079 C14.8366533,21.0087079 17.3893975,19.3027162 18.4725956,16.6864321 C19.5557937,14.0701481 18.9560623,11.0589634 16.9528932,9.05710678 L12.0006254,4.10483898 L7.056875,9.05733849 Z M12.7071068,1.98289322 L18.366875,7.64266151 C20.9420801,10.2161792 21.7131633,14.0877024 20.3204801,17.4514962 C18.9277968,20.8152899 15.645697,23.0087079 12.005,23.0087079 C8.36430295,23.0087079 5.08220318,20.8152899 3.68951994,17.4514962 C2.29683669,14.0877024 3.06791986,10.2161792 5.64226829,7.6435187 L11.2922683,1.9835187 C11.6826911,1.59240487 12.3163383,1.59212475 12.7071068,1.98289322 Z" id="icon--centivo--droplet"/>
      </defs>
      <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-466.000000, -523.000000)"/>
          <g id="Icon/droplet">
              <mask id="mask-2" fill="white">
                  <use xlinkHref="#icon--centivo--droplet"/>
              </mask>
              <use id="Shape" fill="currentColor" xlinkHref="#icon--centivo--droplet"/>
          </g>
      </g>
  </IconWrapper>
)
